module.exports = __webpack_public_path__ + "img/free-kassa-hover.2519a524.png";